/** English UI messages. Every visible string of the app comes from here (spec 004). */
export const en = {
  app: {
    name: 'Arqam',
  },
  nav: {
    main: 'Main',
    today: 'Today',
    journey: 'Journey',
    review: 'Review',
    spaces: 'Spaces',
    settings: 'Settings',
  },
  shell: {
    skipToContent: 'Skip to content',
    home: 'Arqam home',
  },
  theme: {
    label: 'Theme',
    system: 'System',
    light: 'Light',
    dark: 'Dark',
  },
  pages: {
    today: {
      title: 'Today',
    },
    review: {
      title: 'Review',
      description: 'Flashcards that are due today. Nothing is due yet.',
    },
    spaces: {
      title: 'Study spaces',
      description: 'Collect sources, ask al-Murshid and generate notes, cards and quizzes.',
    },
    settings: {
      title: 'Settings',
      description: 'Your account and appearance; AI settings follow.',
    },
    notFound: {
      title: 'Page not found',
      description: 'This page does not exist, or it moved.',
      back: 'Back to Today',
    },
  },
  unavailable: {
    title: 'Arqam cannot be reached',
    description: 'The server did not answer. Check your connection and try again.',
    retry: 'Try again',
  },
} as const

export type Messages = typeof en
